import React, { useCallback, useState } from 'react';
import { ITags } from 'types';
import LanguageBar from './components/LanguageBar';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import Items from './components/Items';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Tags.module.scss';

interface ITagsProps {
	addTags: () => void;
	changeTags: (value: string, item: number, languageId: string) => void;
	deleteTag: (item: number) => void;
	tags: ITags[];
	IDSelectedCustomerDefaultLanguage: Nullable<string>;
	IDsSelectedCustomerLanguages: string[];
}

const Tags: React.FC<ITagsProps> = ({
	addTags,
	changeTags,
	deleteTag,
	tags,
	IDSelectedCustomerDefaultLanguage,
	IDsSelectedCustomerLanguages,
}) => {
	const [selectedLanguage, setSelectedLanguage] = useState<Nullable<string>>(null);
	const [isShowAdditionalTags, setIsShowAdditionalTags] = useState(false);

	const addButtonIsDisabled = IDSelectedCustomerDefaultLanguage !== selectedLanguage;
	const iconNextClasses = classNames(style.iconNext, { [style.rotate]: isShowAdditionalTags });
	const addButtonClasses = classNames({ [style.hide]: addButtonIsDisabled });

	const handleClickHideButton = useCallback(() => {
		setIsShowAdditionalTags(!isShowAdditionalTags);
	}, [isShowAdditionalTags]);

	return (
		<>
			<div className={style.header}>
				<Text
					translationNameSpace="form"
					translationKey="tagsForSearchInMenuHeading"
					theme="secondary"
					size="l"
					weight="bold"
					display="inline"
				/>
				{tags[0]?.tags.length ? (
					<Button
						theme="secondaryPurple"
						onClick={handleClickHideButton}
						disabled={tags.length ? tags[0].tags.length < 4 : true}
						icon={
							<svg className={iconNextClasses}>
								<use xlinkHref={`${breadcrumbs}#rightAngleArrow`} />
							</svg>
						}>
						<Text
							translationNameSpace="form"
							translationKey={isShowAdditionalTags ? 'hideBlockButton' : 'expandBlockButton'}
							asFragment={true}
						/>
					</Button>
				) : (
					<div />
				)}
			</div>
			<div className={style.controls}>
				<LanguageBar
					setSelectedLanguage={setSelectedLanguage}
					onClickHideButton={handleClickHideButton}
					selectedLanguage={selectedLanguage}
					IDSelectedCustomerDefaultLanguage={IDSelectedCustomerDefaultLanguage}
					IDsSelectedCustomerLanguages={IDsSelectedCustomerLanguages}
					tags={tags}
					isShowAdditionalTags={isShowAdditionalTags}
				/>
				<Button
					className={addButtonClasses}
					onClick={addTags}
					disabled={addButtonIsDisabled || tags[0]?.tags.length > 17}
					iconPosition="post"
					icon={
						<svg className={style.iconPlus}>
							<use xlinkHref={`${breadcrumbs}#plus`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="addButton" asFragment={true} />
				</Button>
			</div>
			{tags.map((el) => (
				<Items
					changeTags={changeTags}
					deleteTag={deleteTag}
					tag={el}
					isShowItems={el.languageId === selectedLanguage}
					isShowDeleteIcon={IDSelectedCustomerDefaultLanguage === selectedLanguage}
					isShowAdditionalTags={isShowAdditionalTags}
					key={el.languageId}
				/>
			))}
		</>
	);
};

export default React.memo(Tags);
